/**
 * Created by zhengyf on 2017/11/28.
 */

;(function () {

    DateWeekCtrl.$inject = ['$filter', '$timeout'];
    angular
        .module('app.core')
        .component('dateWeek', {
            template:'<div class="ds-date-week ds-date-animation"><div class="ds-date-week-main"><div class="ds-date-week-header"><i class="iconfont icon-prev" ng-click="vm.f.gotoFirstOrLast(\'first\')"></i> <i class="iconfont icon-back" ng-click="vm.f.toggleYM(\'prev\')"></i><div class="ds-cur-ym"><span class="ym" ng-bind="vm.d.curYM"></span></div><i class="iconfont icon-more i-more" ng-click="vm.f.toggleYM(\'next\')"></i> <i class="iconfont icon-prev i-rotate" ng-click="vm.f.gotoFirstOrLast(\'last\')"></i></div><div class="ds-date-week-body"><div class="ds-date-week-items" style="display: block;"><div class="ds-date-week-item" ng-repeat="week in vm.d.curDateRange track by $index" ng-class="{\'ds-date-week-item-selected\': week.selected}" ng-click="vm.f.getWeekRange(week, $index)"><span ng-bind="week.dateStart">2017-11-05</span> <span>至</span> <span ng-bind="week.dateEnd">2017-11-11</span></div></div></div></div></div>',
            bindings: {
                max: '<',
                weekRange: '=',
                onChange: '&',
            },
            controllerAs: 'vm',
            controller: DateWeekCtrl
        })

    function DateWeekCtrl($filter, $timeout) {

        var vm = this;

        this.$onInit = onInit;
        this.$onChanges = bindingsOnChanges;

        var DAY_FLAG = '0123456';
        var DAY_TIMES_TAMP = 24 * 3.6e3 * 1e3;

        var curMonthIndex;
        var maxMonthIndex;
        var monthList = [];
        var selectedWeek = {
            dateStart: '',
            dateEnd: ''
        };

        vm.c = {
            weekRange: null
        };

        vm.d = {
            curYM: '',
            curDateRange: []
        };

        vm.f = {
            toggleYM: toggleYM,
            gotoFirstOrLast: gotoFirstOrLast,
            getWeekRange: getWeekRange
        }

        function onInit() {

        }

        function bindingsOnChanges(changes) {

            if (changes.max) {

                if (!vm.max) {
                    return;
                }

                vm.c.weekRange = get12Week(vm.max);
                vm.weekRange = vm.c.weekRange;
                handleWeekRange();
            }
        }

        /**
         * 获得所有周 一周（周日-周六）
         * @param curDate 当前日期
         * @returns {{}} 周日期及所属月份
         */
        function get12Week(curDate) {
            var result = {};
            curDate = $filter('date')(curDate, 'yyyy-MM-dd'); // 当前年月日
            var formatCurDateMS = new Date(curDate); // 转化为毫秒
            var curDay = DAY_FLAG.charAt(formatCurDateMS.getDay()); // 获得当前时间为周几

            // 获得最近的日期毫秒数
            var dateEnd = formatCurDateMS - DAY_TIMES_TAMP * (+curDay + 1);
            var   dateStart = dateEnd - DAY_TIMES_TAMP * 6;

            // 获得最近一周的月份
            var lastMonth = $filter('date')(new Date(dateStart), 'yyyy-MM');

            // 存放这个月的所有周
            result[lastMonth] = [];
            result[lastMonth].push({
                dateStart: $filter('date')(new Date(dateStart), 'yyyy-MM-dd'),
                dateEnd: $filter('date')(new Date(dateEnd), 'yyyy-MM-dd')
            });

            // 12周
            for (var i = 0; i < 11; i++) {
                dateEnd = dateStart - DAY_TIMES_TAMP; // 周六
                dateStart = dateEnd - DAY_TIMES_TAMP * 6; // 周日
                // 一周
                var weekRange = {
                    dateStart: $filter('date')(new Date(dateStart), 'yyyy-MM-dd'),
                    dateEnd: $filter('date')(new Date(dateEnd), 'yyyy-MM-dd')
                };

                // 当前周所属月份
                var month = $filter('date')(new Date(dateStart), 'yyyy-MM');

                // 如果本月还没有存入一周 初始化为[]
                if (!result[month]) {
                    result[month] = [];
                }

                result[month].unshift(weekRange);
            }
            return result;
        }

        // 处理vm.c.weekRange 用于切换年月
        function handleWeekRange() {

            for (var attr in vm.c.weekRange) {
                monthList.push(attr);
            }

            monthList.reverse();
            maxMonthIndex = monthList.length - 1;
            curMonthIndex = maxMonthIndex;
            setYM();
            toggleWeekStatus(vm.d.curDateRange, vm.d.curDateRange.length - 1);
        }

        // 按月切换月份
        function toggleYM(option) {
            curMonthIndex = option === 'next' ? curMonthIndex + 1 : curMonthIndex - 1;
            if (curMonthIndex > maxMonthIndex) {
                curMonthIndex = curMonthIndex - 1;
                // 设置class
                return;
            }

            if (curMonthIndex < 0) {
                curMonthIndex = curMonthIndex + 1;
                // 设置class
                return;
            }

            setYM();
        }

        // 调到最大最小月份
        function gotoFirstOrLast(position) {
            curMonthIndex = position === 'last' ? maxMonthIndex : 0;
            setYM();
        }

        // 设置年月
        function setYM() {
            vm.d.curYM = monthList[curMonthIndex];
            resetWeekStatus(vm.c.weekRange[vm.d.curYM]);
            vm.d.curDateRange = vm.c.weekRange[vm.d.curYM];

            for (var i = 0; i < vm.d.curDateRange.length; i++) {
                if (vm.d.curDateRange[i].dateStart === selectedWeek.dateStart) {
                    vm.d.curDateRange[i].selected = true;
                }
            }
        }

        function toggleWeekStatus(tab, index) {
            resetWeekStatus(tab);
            tab[index].selected = true;
        }

        function resetWeekStatus(tab) {
            for (var i = 0; i < tab.length; i++) {
                tab[i].selected = false;
            }
        }

        // 选择周 传给外部调用函数
        function getWeekRange(weekRange, index) {
            var dateStart = weekRange.dateStart;
            var dateEnd = weekRange.dateEnd;
            toggleWeekStatus(vm.d.curDateRange, index);
            selectedWeek = vm.d.curDateRange[index];

            onChange({
                $event: {
                    start: dateStart,
                    end: dateEnd,
                }
            });
        }

        // 选择的周改变
        function onChange(weekDateRange) {
            if ('function' === typeof vm.onChange) {
                vm.onChange(weekDateRange);
            }
        }


    }

})()